import { SectionMark } from "@/components/section-mark";

const results = [
  {
    lead: "Podejmujesz decyzje spokojniej.",
    rest: "Rozpoznajesz, kiedy prowadzi Cię doświadczenie i dane, a kiedy presja, lęk albo potrzeba kontroli.",
  },
  {
    lead: "Niesiesz tylko to, co Twoje.",
    rest: "Oddzielasz odpowiedzialność, którą naprawdę masz, od tej, którą bierzesz z przyzwyczajenia.",
  },
  {
    lead: "Rozumiesz własne reakcje.",
    rest: "Widzisz schematy, które doprowadziły Cię do sukcesu, i świadomie wybierasz, które z nich nadal Ci służą.",
  },
  {
    lead: "Stawiasz granice bez poczucia winy.",
    rest: "Wobec zespołu, wspólników i klientów, ale też wobec własnych oczekiwań.",
  },
  {
    lead: "Masz miejsce na życie poza pracą.",
    rest: "Nie kosztem ambicji. Po to, żeby sukces nie wymagał rezygnowania z siebie.",
  },
];

export function ResultsSection() {
  return (
    <section id="rezultaty" className="content-visibility-auto scroll-mt-24 border-b border-ink/10 bg-surface">
      <div className="container-page grid gap-8 py-12 md:py-16">
        <div className="grid gap-8 md:grid-cols-2 md:items-end md:gap-12 lg:gap-16">
          <div>
            <SectionMark number="05" label="Rezultaty" />
            <h2 className="display-xl mt-8 text-[1.9rem] md:text-[2.4rem]">
              Nie chodzi o to, żeby robić{" "}
              <span className="serif-display italic text-coral-text">więcej</span>.
            </h2>
          </div>
        </div>
        <div className="min-w-0">
          <ul className="grid gap-x-10 gap-y-6 border-t border-steel pt-8 md:grid-cols-2 lg:grid-cols-3">
            {results.map((item, index) => (
              <li
                key={item.lead}
                className={`flex gap-5 ${index === results.length - 1 ? "lg:col-span-2" : ""}`}
              >
                <p className="text-base leading-relaxed text-ink/80 md:text-lg">
                  <span className="font-semibold text-ink">{item.lead}</span> {item.rest}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
